import type { APIErrorCode, APIFieldError } from '@/lib/api/apiTypes';

export class APIError extends Error {
  status: number;
  code?: APIErrorCode | string;
  fieldErrors: APIFieldError[];
  requestID?: string;

  constructor(
    message: string,
    status: number,
    code?: APIErrorCode | string,
    options: { fieldErrors?: APIFieldError[]; requestID?: string } = {}
  ) {
    super(message);
    this.status = status;
    this.code = code;
    this.fieldErrors = options.fieldErrors ?? [];
    this.requestID = options.requestID;
  }
}
